import { filter, includes } from "lodash";
import { isSuperAdmin } from "@linkfluence/models/role";
import { useCurrentProject } from "@radarly/core/project/use-cases";
import { useCurrentUserLevel } from "@radarly/core/user/use-cases";
import { isRoot } from "@radarly/models/level";
import { useContextualProjectUserData } from "./useContextualProjectUserData";
import { useContextualProjectUserRole } from "./useContextualProjectUserRole";

function useContextualProjectUserWorkspaceIds() {
  const data = useContextualProjectUserData();
  return data ? data.dashboardIds : [];
}

export function useContextualWorkspaces() {
  const level = useCurrentUserLevel();
  const role = useContextualProjectUserRole();
  const project = useCurrentProject();
  const workspaces = project?.dashboards;
  const workspaceIds = useContextualProjectUserWorkspaceIds();
  return filter(workspaces, ({ id }) => {
    return (
      isRoot(level) ||
      isSuperAdmin(role) ||
      project.flags.isPublic ||
      includes(workspaceIds, id)
    );
  });
}
